import {
  Autocomplete,
  Box,
  IconButton,
  MenuItem,
  Stack,
  styled,
  TextField,
  Toolbar,
} from "@mui/material";
import {
  addDays,
  endOfDay,
  startOfDay,
  subDays,
  subHours,
  format,
} from "date-fns";
import React, { useEffect, useState } from "react";
import { statusMap } from "../InboxPage";

import { DateRangePicker } from "rsuite";
import "rsuite/dist/rsuite.min.css";
import moment from "moment";
import { BACKEND_URL } from "../../../helpers/variables";
import { useLoaderData } from "react-router-dom";
import { Refresh } from "@mui/icons-material";

const { afterToday } = DateRangePicker;

const MIN_WIDTH = 300;
const filterOptions = ["Range", "Today", "Yesterday", "Recent"];
const TODAY = new Date();
const TODAY_RANGE = [startOfDay(TODAY), TODAY];

const HeaderTextField = styled(TextField)(({ theme }) => ({
  "& .MuiInputLabel-root": {
    fontSize: 12,
  },
}));

/**
 * @param {Object} props
 * @param {Array<Object>} props.emails
 * @param {Object} props.filters
 * @param {Array<Date>} props.filters.dateRange
 * @param {"Range" | "Today" | "Yesterday" | "Recent"} props.filters.transaction
 * @param {Number | string} props.filters.status
 * @param {string} props.filters.vendor_name
 * @param {Number} props.filters.stream_count
 * @param {(key: 'dateRange' | 'transaction' | 'status' | 'stream_count', value: string | Array<Date> | null | Number) => void} props.updateFilter
 */
const InboxHeader = ({ filters, updateFilter }) => {
  let { client_url, corporation_id } = useLoaderData();
  const [vendors, seVendors] = useState([]);

  useEffect(() => {
    get_all_vendors();
  }, [filters]);

  async function get_all_vendors() {
    seVendors([]);
    let { dateRange, status } = filters;
    let [startDate, endDate] = dateRange?.map((date) => date.toISOString()) || [
      null,
      null,
    ];

    const params = new URLSearchParams({
      status,
      corporation_id,
      client_url,
      ...(startDate && endDate && { start_date: startDate, end_date: endDate }),
    }).toString();

    let res = await fetch(`${BACKEND_URL}/get_all_vendors?${params}`);

    let data = await res.json();
    seVendors(["All", ...data]);
  }

  useEffect(() => {
    let transaction = filters.transaction;

    const dateRanges = {
      Range: null,
      Today: TODAY_RANGE,
      Yesterday: [startOfDay(subDays(TODAY, 1)), endOfDay(subDays(TODAY, 1))],
      Recent: [subHours(TODAY, 2), TODAY],
    };

    updateFilter("dateRange", dateRanges[transaction]);
  }, [filters.transaction]);

  const predefinedRanges = [
    {
      label: "Today",
      value: [startOfDay(TODAY), new Date()],
    },
    {
      label: "Yesterday",
      value: [startOfDay(subDays(TODAY, 1)), endOfDay(subDays(TODAY, 1))],
    },
    // {
    //   label: "Recent",
    //   value: [subHours(TODAY, 2), TODAY],
    //   placement: "left",
    // },
    {
      label: "Last 7 days",
      value: [startOfDay(subDays(TODAY, 6)), new Date()],
    },
  ];

  return (
    <Stack direction="row" alignItems="center" gap={2}>
      <HeaderTextField
        select
        label="Status"
        value={filters.status}
        onChange={(e) => updateFilter("status", e.target.value)}
        size="small"
        sx={{ minWidth: MIN_WIDTH }}
        variant="filled"
        margin="none"
      >
        <MenuItem value={"all"}>All</MenuItem>
        {Object.entries(statusMap).map(
          ([status, stats], index) =>
            !stats["hide"] && (
              <MenuItem key={index} value={status}>
                {stats.name}
              </MenuItem>
            )
        )}
      </HeaderTextField>

      <Autocomplete
        options={vendors}
        size="small"
        value={filters.vendor_name}
        onChange={(e, v) => updateFilter("vendor_name", v)}
        sx={{ minWidth: MIN_WIDTH }}
        disableClearable
        renderInput={(props) => (
          <HeaderTextField
            {...props}
            variant="filled"
            label="Search vendor"
            margin="none"
          />
        )}
      />

      {/* <HeaderTextField
        select
        label="View Transactions"
        value={filters.transaction}
        onChange={(e) => {
          updateFilter("transaction", e.target.value);
          updateFilter("dateRange", null);
        }}
        size="small"
        sx={{ minWidth: MIN_WIDTH }}
        variant="filled"
        margin="none"
      >
        {filterOptions.map((filter) => (
          <MenuItem key={filter} value={filter}>
            {filter}
          </MenuItem>
        ))}
      </HeaderTextField> */}

      <Box flexGrow={1}>
        <DateRangePicker
          value={filters.dateRange}
          placeholder="From & To"
          onChange={(v) =>
            updateFilter("dateRange", v ? [v[0], endOfDay(v[1])] : v)
          }
          ranges={predefinedRanges}
          showHeader={false}
          format={"MM/dd/yyyy"}
          // showOneCalendar
          // shouldDisableDate={afterToday()}
        />
      </Box>

      <Box>
        <IconButton
          onClick={() => updateFilter("stream_count", filters.stream_count + 1)}
        >
          <Refresh />
        </IconButton>
      </Box>
    </Stack>
  );
};

export default InboxHeader;

function requestSearch(query, data = [], keys = []) {
  function string(str) {
    return str?.toString().toLowerCase().replace(/\s/g, "");
  }
  const filteredQuery = string(query);
  let final_keys = keys.length > 0 ? keys : Object.keys(data[0]);

  const filterData = data.filter((i) =>
    final_keys.some((key) => {
      let value = Array.isArray(i[key]) ? i[key][0] : i[key];
      value = string(value);
      return value?.includes(filteredQuery);
    })
  );

  return filterData;
}
